/* Згоди та документи клієнта (/consents, batch B8). Kept apart from uk.ts/en.ts to keep merges small. */
export const consentsUk = {
  'nav.consents': 'Згоди',
  'perm.consents.work': 'Згоди: генерація, підпис на планшеті, надсилання клієнту, реєстр',
  'perm.consents.manage': 'Згоди: шаблони, версії та пакети',
  'consents.title': 'Згоди',
  'consents.subtitle': 'Договори, інформовані згоди та відмови: генерація для візиту або ВРІТ, підпис на планшеті чи дистанційно, реєстр «хто що підписав».',
  'consents.tabRegister': 'Реєстр',
  'consents.tabTemplates': 'Шаблони',
  'consents.tabPacks': 'Пакети',
  'consents.generate': 'Згенерувати документ',
  'consents.generateTitle': 'Новий документ для підпису',
  'consents.generateHint': 'Дані клієнта, тварини, лікаря й дату Bridge підставить з Enote.',
  'consents.generateButton': 'Згенерувати',
  'consents.generatePack': 'Згенерувати пакет',
  'consents.searchPlaceholder': 'Клієнт, тварина або документ',
  'consents.statusFilter': 'Статус',
  'consents.anyStatus': 'Усі статуси',
  'consents.templateFilter': 'Шаблон',
  'consents.anyTemplate': 'Усі шаблони',
  'consents.filteredByPatient': 'Показано документи одного пацієнта',
  'consents.empty': 'Документів ще немає',
  'consents.emptyHint':
    'Згенеруйте документ для візиту, запису або пацієнта ВРІТ. Спершу адміністратор вставляє затверджений текст у шаблон і публікує версію (вкладка «Шаблони»).',
  'consents.colDate': 'Дата',
  'consents.colDocument': 'Документ',
  'consents.colPatient': 'Пацієнт',
  'consents.colStatus': 'Статус',
  'consents.colSigned': 'Підписано',
  'consents.moreRows': 'Ще {n} — уточніть фільтр',
  'consents.document': 'Документ',
  'consents.template': 'Шаблон',
  'consents.client': 'Клієнт',
  'consents.pet': 'Тварина',
  'consents.visit': 'Візит',
  'consents.noVisit': 'Без візиту',
  'consents.procedure': 'Процедура / маніпуляція',
  'consents.procedureHint': 'Підставляється в {{procedure}}.',
  'consents.doctor': 'Лікар',
  'consents.price': 'Орієнтовна вартість, грн',
  'consents.priceHint': 'Підставляється в {{price}}. Бачать лише співробітники з доступом до грошей.',
  'consents.badPrice': 'Введіть суму числом',
  'consents.priceHiddenHint': 'Документ містить суму: показати його клієнту на планшеті чи роздрукувати може адміністратор, або надішліть його клієнту в застосунок / бот.',
  'consents.date': 'Дата документа',
  'consents.dateHint': 'Порожньо — сьогодні.',
  'consents.branch': 'Філія',
  'consents.branch.kharkiv': 'Харків',
  'consents.branch.kyiv': 'Київ',
  'consents.created': 'Створено',
  'consents.expires': 'Дійсний до',
  'consents.signedBy': 'Підписав(ла)',
  'consents.signedFrom': 'IP / пристрій',
  'consents.doctorSigned': 'Лікар (підпис)',
  'consents.hash': 'SHA-256 тексту',
  'consents.declineReason': 'Причина відмови',
  'consents.voidReason': 'Причина скасування',
  'consents.signature': 'Підпис',
  'consents.audit': 'Журнал дій',
  'consents.open': 'Відкрити',
  'consents.signTablet': 'Підписати на планшеті',
  'consents.sendRemote': 'Надіслати клієнту',
  'consents.resend': 'Надіслати ще раз',
  'consents.sent': 'Посилання надіслано: {n}',
  'consents.signPaper': 'Підписано на папері',
  'consents.signPaperHint': 'Роздрукований документ підписано на папері (напр. при відключенні світла). Оригінал зберігається в клініці.',
  'consents.paperNote': 'Де зберігається оригінал',
  'consents.paperReceived': 'Паперовий примірник отримано',
  'consents.paperMissing': 'Потрібен паперовий примірник',
  'consents.requiresPaperShort': 'Потрібен папір',
  'consents.requiresPaperHint':
    'Для цього документа клініка поки зберігає також підписаний паперовий примірник (рішення власника 06 §4.4 про достатність електронного підпису ще не ухвалено).',
  'consents.declineAction': 'Відмова від підпису',
  'consents.voidAction': 'Скасувати документ',
  'consents.voidHint': 'Документ лишиться в реєстрі зі статусом «скасовано».',
  'consents.reason': 'Причина',
  'consents.signerName': 'ПІБ того, хто підписує',
  'consents.print': 'Друк',
  'consents.printBlank': 'Друк бланка',
  'consents.status.draft': 'Чернетка',
  'consents.status.sent': 'Надіслано клієнту',
  'consents.status.signed': 'Підписано',
  'consents.status.declined': 'Відмова',
  'consents.status.expired': 'Прострочено',
  'consents.status.void': 'Скасовано',
  'consents.status.open': 'Очікують підпису',
  'consents.status.missing': 'Немає',
  'consents.via.tablet': 'планшет',
  'consents.via.remote': 'дистанційно',
  'consents.via.paper': 'папір',
  'consents.event.created': 'Створено',
  'consents.event.sent': 'Надіслано клієнту',
  'consents.event.opened': 'Клієнт відкрив',
  'consents.event.signed': 'Підписано',
  'consents.event.declined': 'Відмова',
  'consents.event.expired': 'Минув строк',
  'consents.event.void': 'Скасовано',
  'consents.event.paper_received': 'Паперовий примірник отримано',
  'consents.event.downloaded': 'Завантажено / друк',
  'consents.event.linked': 'Прив’язано до перебування у ВРІТ',
  'consents.kind.contract': 'Договір',
  'consents.kind.consent': 'Згода',
  'consents.kind.refusal': 'Відмова',
  'consents.kind.application': 'Заява',
  'consents.kind.act': 'Акт',
  'consents.searchPatient': 'Пацієнт',
  'consents.searchPatientHint': 'Кличка, власник або чип (від 2 літер).',
  'consents.noPatients': 'Нікого не знайдено',
  'consents.inVrit': 'у ВРІТ',
  'consents.linkStay': 'Прив’язати до перебування у ВРІТ',
  'consents.what': 'Пакет або шаблон',
  'consents.chooseWhat': 'Оберіть…',
  'consents.nothingPublished': 'Жоден шаблон ще не опубліковано — генерувати нічого. Адміністратор публікує тексти у вкладці «Шаблони».',
  'consents.nothingGenerated': 'Нових документів немає: усе з пакета вже підписано.',
  'consents.signTitle': 'Підпис документа',
  'consents.signHere': 'Підпис пальцем або стилусом',
  'consents.clear': 'Очистити',
  'consents.signButton': 'Підписати',
  'consents.signLegal': 'Підписуючи, ви підтверджуєте, що ознайомилися з текстом. Фіксуються ПІБ, час, IP-адреса та пристрій.',
  'consents.signedThanks': 'Документ підписано. Дякуємо!',
  'consents.backToRegister': 'Повернути планшет співробітнику',
  'consents.doctorSigns': 'Документ підписує також лікар — підпис зараховується лікарю {name}.',
  'consents.templatesHint':
    'Шаблони створено як чернетки зі структурою з документів клініки — юридичного тексту Bridge не вигадує. Вставте затверджений текст, збережіть і опублікуйте версію; документи зберігають версію, з якої їх створено.',
  'consents.newTemplate': 'Новий шаблон',
  'consents.seed': 'Додати шаблони з документів',
  'consents.seeded': 'Додано шаблонів: {t}, пакетів: {p}',
  'consents.noTemplates': 'Шаблонів ще немає',
  'consents.noTemplatesHint': 'Натисніть «Додати шаблони з документів» — з’являться чернетки ≈20 форм клініки (договір, згоди, відмови, заяви).',
  'consents.colTemplate': 'Шаблон',
  'consents.colKind': 'Тип',
  'consents.colState': 'Стан',
  'consents.colSigning': 'Підписання',
  'consents.tplStatus.draft': 'Чернетка',
  'consents.tplStatus.active': 'Опубліковано',
  'consents.tplStatus.archived': 'В архіві',
  'consents.toConfirm': 'Уточнити',
  'consents.draftChanged': 'Є неопубліковані зміни',
  'consents.remoteYes': 'Можна дистанційно',
  'consents.remoteNo': 'Лише в клініці',
  'consents.signer.client': 'Підписує клієнт',
  'consents.signer.client_doctor': 'Клієнт + лікар',
  'consents.signerLabel': 'Хто підписує',
  'consents.templateHint': 'Розмітка: # заголовок, ## розділ, - пункт, **жирний**, > примітка, --- лінія.',
  'consents.tplTitle': 'Назва',
  'consents.tplKey': 'Ключ',
  'consents.tplKeyHint': 'Латиницею, напр. surgery_consent',
  'consents.validDays': 'Діє днів',
  'consents.validDaysHint': 'Скільки днів підпис зараховується в пакет; порожньо — без обмеження (договір).',
  'consents.flag.requires_paper': 'Потрібен паперовий примірник',
  'consents.flag.remote_allowed': 'Можна підписати дистанційно',
  'consents.flag.shows_price': 'Містить суму',
  'consents.flag.to_confirm': 'Уточнити у власника',
  'consents.body': 'Текст',
  'consents.bodyHint': 'Поля: {list}',
  'consents.unknownPlaceholders': 'Невідомі поля: {list}',
  'consents.draftStructureHint': 'Це ще чернетка структури: замініть позначки «[Текст розділу…]» і примітку на затверджений текст, тоді можна публікувати.',
  'consents.description': 'Опис / джерело',
  'consents.saveDraft': 'Зберегти чернетку',
  'consents.saved': 'Збережено',
  'consents.publish': 'Опублікувати версію',
  'consents.publishNote': 'Що змінено (необов’язково)',
  'consents.published': 'Опубліковано версію {v}',
  'consents.saveFirst': 'Спершу збережіть зміни',
  'consents.archive': 'В архів',
  'consents.restore': 'Повернути з архіву',
  'consents.versions': 'Опубліковані версії',
  'consents.notPublished': 'не опубліковано',
  'consents.packsHint':
    'Пакет — документи, які підписують разом. Активний пакет «Госпіталізація (ВРІТ)» обов’язковий для заселення у ВРІТ: без нього лікар приймає пацієнта лише з причиною.',
  'consents.newPack': 'Новий пакет',
  'consents.noPacks': 'Пакетів ще немає',
  'consents.packStatus.draft': 'Чернетка',
  'consents.packStatus.active': 'Діє',
  'consents.packStatus.archived': 'В архіві',
  'consents.packNotReady': 'не всі шаблони опубліковано',
  'consents.packDialogHint': 'Активувати пакет можна, коли всі його шаблони опубліковано.',
  'consents.packStatusHint': '«Діє» — пакет вимагається там, де він використовується (ВРІТ).',
  'consents.packTemplates': 'Шаблони пакета',
  'consents.stayPack': 'Пакет згод на госпіталізацію',
  'consents.packComplete': 'підписано',
  'consents.packIncomplete': 'не підписано',
  'consents.packInactive': 'пакет ще не діє',
  'consents.packInactiveHint': 'Поки пакет не активовано у «Згодах», діє ручний чекліст документів.',
  'consents.overrideReason': 'Прийняти без підписаного пакета згод — причина',
  'consents.overrideHint': 'Лише лікар, напр. «критичний стан — документи після стабілізації». Порожньо, якщо пакет підписано.',
  'consents.packMissing': 'Пакет згод на госпіталізацію не підписано: згенеруйте й підпишіть його в «Згодах» або вкажіть причину.',
  'vrit.warn.consent_override': 'прийнято без згод (причина лікаря)',
  'vrit.warn.no_discharge_consent': 'немає згоди на виписку',
}

export const consentsEn: { [K in keyof typeof consentsUk]?: string } = {
  'nav.consents': 'Consents',
  'perm.consents.work': 'Consents: generate, sign on tablet, send to client, register',
  'perm.consents.manage': 'Consents: templates, versions and packs',
  'consents.title': 'Consents',
  'consents.subtitle': 'Contracts, informed consents and refusals: generated for a visit or ICU stay, signed on a tablet or remotely, a register of who signed what.',
  'consents.tabRegister': 'Register',
  'consents.tabTemplates': 'Templates',
  'consents.tabPacks': 'Packs',
  'consents.generate': 'Generate document',
  'consents.generateTitle': 'New document to sign',
  'consents.generateHint': 'Client, pet, doctor and date are filled from Enote.',
  'consents.generateButton': 'Generate',
  'consents.generatePack': 'Generate pack',
  'consents.searchPlaceholder': 'Client, pet or document',
  'consents.statusFilter': 'Status',
  'consents.anyStatus': 'All statuses',
  'consents.templateFilter': 'Template',
  'consents.anyTemplate': 'All templates',
  'consents.filteredByPatient': 'Documents of one patient',
  'consents.empty': 'No documents yet',
  'consents.emptyHint': 'Generate a document for a visit, appointment or ICU patient. First an administrator pastes the approved text into a template and publishes it (Templates tab).',
  'consents.colDate': 'Date',
  'consents.colDocument': 'Document',
  'consents.colPatient': 'Patient',
  'consents.colStatus': 'Status',
  'consents.colSigned': 'Signed',
  'consents.moreRows': '{n} more — narrow the filter',
  'consents.document': 'Document',
  'consents.template': 'Template',
  'consents.client': 'Client',
  'consents.pet': 'Pet',
  'consents.visit': 'Visit',
  'consents.noVisit': 'No visit',
  'consents.procedure': 'Procedure',
  'consents.procedureHint': 'Filled into {{procedure}}.',
  'consents.doctor': 'Doctor',
  'consents.price': 'Price estimate, UAH',
  'consents.priceHint': 'Filled into {{price}}. Visible only to staff who see money.',
  'consents.badPrice': 'Enter a number',
  'consents.priceHiddenHint': 'The document has a price: an administrator shows it on the tablet or prints it, or send it to the client’s app / bot.',
  'consents.date': 'Document date',
  'consents.dateHint': 'Empty — today.',
  'consents.branch': 'Branch',
  'consents.branch.kharkiv': 'Kharkiv',
  'consents.branch.kyiv': 'Kyiv',
  'consents.created': 'Created',
  'consents.expires': 'Valid until',
  'consents.signedBy': 'Signed by',
  'consents.signedFrom': 'IP / device',
  'consents.doctorSigned': 'Doctor (signature)',
  'consents.hash': 'Text SHA-256',
  'consents.declineReason': 'Refusal reason',
  'consents.voidReason': 'Void reason',
  'consents.signature': 'Signature',
  'consents.audit': 'Audit trail',
  'consents.open': 'Open',
  'consents.signTablet': 'Sign on tablet',
  'consents.sendRemote': 'Send to client',
  'consents.resend': 'Send again',
  'consents.sent': 'Link sent: {n}',
  'consents.signPaper': 'Signed on paper',
  'consents.signPaperHint': 'The printed document was signed on paper (e.g. power cut). The original is kept by the clinic.',
  'consents.paperNote': 'Where the original is kept',
  'consents.paperReceived': 'Paper copy received',
  'consents.paperMissing': 'Paper copy needed',
  'consents.requiresPaperShort': 'Paper needed',
  'consents.requiresPaperHint': 'For this document the clinic still keeps a signed paper copy (owner decision 06 §4.4 on electronic signatures is open).',
  'consents.declineAction': 'Refused to sign',
  'consents.voidAction': 'Void document',
  'consents.voidHint': 'The document stays in the register as void.',
  'consents.reason': 'Reason',
  'consents.signerName': 'Full name of the signer',
  'consents.print': 'Print',
  'consents.printBlank': 'Print blank',
  'consents.status.draft': 'Draft',
  'consents.status.sent': 'Sent to client',
  'consents.status.signed': 'Signed',
  'consents.status.declined': 'Declined',
  'consents.status.expired': 'Expired',
  'consents.status.void': 'Void',
  'consents.status.open': 'Awaiting signature',
  'consents.status.missing': 'Missing',
  'consents.via.tablet': 'tablet',
  'consents.via.remote': 'remote',
  'consents.via.paper': 'paper',
  'consents.event.created': 'Created',
  'consents.event.sent': 'Sent to client',
  'consents.event.opened': 'Client opened',
  'consents.event.signed': 'Signed',
  'consents.event.declined': 'Declined',
  'consents.event.expired': 'Expired',
  'consents.event.void': 'Voided',
  'consents.event.paper_received': 'Paper copy received',
  'consents.event.downloaded': 'Downloaded / printed',
  'consents.event.linked': 'Linked to the ICU stay',
  'consents.kind.contract': 'Contract',
  'consents.kind.consent': 'Consent',
  'consents.kind.refusal': 'Refusal',
  'consents.kind.application': 'Application',
  'consents.kind.act': 'Act',
  'consents.searchPatient': 'Patient',
  'consents.searchPatientHint': 'Pet name, owner or chip (2+ letters).',
  'consents.noPatients': 'Nobody found',
  'consents.inVrit': 'in ICU',
  'consents.linkStay': 'Link to the ICU stay',
  'consents.what': 'Pack or template',
  'consents.chooseWhat': 'Choose…',
  'consents.nothingPublished': 'No template is published yet. An administrator publishes the texts in the Templates tab.',
  'consents.nothingGenerated': 'Nothing new: everything in the pack is already signed.',
  'consents.signTitle': 'Sign document',
  'consents.signHere': 'Sign with a finger or stylus',
  'consents.clear': 'Clear',
  'consents.signButton': 'Sign',
  'consents.signLegal': 'By signing you confirm you have read the text. Name, time, IP address and device are recorded.',
  'consents.signedThanks': 'Signed. Thank you!',
  'consents.backToRegister': 'Hand the tablet back',
  'consents.doctorSigns': 'A doctor co-signs this document — the signature is recorded for {name}.',
  'consents.templatesHint':
    'Templates are seeded as drafts with the structure from the clinic documents — Bridge does not invent legal text. Paste the approved text, save and publish a version; documents keep the version they were made from.',
  'consents.newTemplate': 'New template',
  'consents.seed': 'Add templates from documents',
  'consents.seeded': 'Templates added: {t}, packs: {p}',
  'consents.noTemplates': 'No templates yet',
  'consents.noTemplatesHint': 'Click «Add templates from documents» to get drafts of ≈20 clinic forms (contract, consents, refusals, applications).',
  'consents.colTemplate': 'Template',
  'consents.colKind': 'Kind',
  'consents.colState': 'State',
  'consents.colSigning': 'Signing',
  'consents.tplStatus.draft': 'Draft',
  'consents.tplStatus.active': 'Published',
  'consents.tplStatus.archived': 'Archived',
  'consents.toConfirm': 'To confirm',
  'consents.draftChanged': 'Unpublished changes',
  'consents.remoteYes': 'Remote allowed',
  'consents.remoteNo': 'In clinic only',
  'consents.signer.client': 'Client signs',
  'consents.signer.client_doctor': 'Client + doctor',
  'consents.signerLabel': 'Signed by',
  'consents.templateHint': 'Markup: # title, ## section, - item, **bold**, > note, --- line.',
  'consents.tplTitle': 'Title',
  'consents.tplKey': 'Key',
  'consents.tplKeyHint': 'Latin, e.g. surgery_consent',
  'consents.validDays': 'Valid days',
  'consents.validDaysHint': 'Days a signature counts for packs; empty — no limit (contract).',
  'consents.flag.requires_paper': 'Paper copy required',
  'consents.flag.remote_allowed': 'Remote signing allowed',
  'consents.flag.shows_price': 'Has a price',
  'consents.flag.to_confirm': 'To confirm with the owner',
  'consents.body': 'Text',
  'consents.bodyHint': 'Fields: {list}',
  'consents.unknownPlaceholders': 'Unknown fields: {list}',
  'consents.draftStructureHint': 'This is still the draft structure: replace the «[Текст розділу…]» marks and the note with the approved text, then publish.',
  'consents.description': 'Description / source',
  'consents.saveDraft': 'Save draft',
  'consents.saved': 'Saved',
  'consents.publish': 'Publish version',
  'consents.publishNote': 'What changed (optional)',
  'consents.published': 'Version {v} published',
  'consents.saveFirst': 'Save the changes first',
  'consents.archive': 'Archive',
  'consents.restore': 'Restore',
  'consents.versions': 'Published versions',
  'consents.notPublished': 'not published',
  'consents.packsHint': 'A pack is a set of documents signed together. The active «Hospitalisation (ICU)» pack is required for ICU admission; without it a doctor admits only with a reason.',
  'consents.newPack': 'New pack',
  'consents.noPacks': 'No packs yet',
  'consents.packStatus.draft': 'Draft',
  'consents.packStatus.active': 'Active',
  'consents.packStatus.archived': 'Archived',
  'consents.packNotReady': 'not all templates published',
  'consents.packDialogHint': 'A pack can be activated once every template is published.',
  'consents.packStatusHint': '«Active» — the pack is required where it is used (ICU).',
  'consents.packTemplates': 'Templates of the pack',
  'consents.stayPack': 'Hospitalisation consent pack',
  'consents.packComplete': 'signed',
  'consents.packIncomplete': 'not signed',
  'consents.packInactive': 'pack not active yet',
  'consents.packInactiveHint': 'Until the pack is activated in Consents, the manual documents checklist applies.',
  'consents.overrideReason': 'Admit without the signed consent pack — reason',
  'consents.overrideHint': 'Doctors only, e.g. «critical state — documents after stabilisation». Empty if the pack is signed.',
  'consents.packMissing': 'The hospitalisation consent pack is not signed: generate and sign it in Consents or give a reason.',
  'vrit.warn.consent_override': 'admitted without consents (doctor’s reason)',
  'vrit.warn.no_discharge_consent': 'no discharge consent',
}
